module.exports.copyToClipboard = (text) => {
  var dummy = document.createElement('textarea')
  document.body.appendChild(dummy)
  dummy.value = text
  dummy.select()
  document.execCommand('copy')
  document.body.removeChild(dummy)
}

module.exports.toCsv = (array) => {
  let toReturn = []
  let line

  // Ajout de l'entête
  toReturn.push(Object.keys(array[0]).join(','))

  array.forEach(function (d, index) {
    line = Object.values(d).map((d) => d.toString().split(',').join(' ')).join(',')
    toReturn.push(line)
  })

  return toReturn.join('\n')
}
